export type AreaWithRegion = {
  name: string;
  level: { depth: number };
  region: { name: string } | null;
};

type AddressWithArea = {
  area: AreaWithRegion | null;
  city: string;
};

/** Top-level area name (region, department, province, state...). */
export const getRegionName = (
  area: AreaWithRegion | null | undefined,
): string | null => area?.region?.name ?? null;

/**
 * Locality an address points to: the address-level area when it sits below
 * the top level, otherwise the free-text city typed for countries that only
 * have a top level.
 */
export const getLocalityName = (
  address: AddressWithArea | null | undefined,
): string | null => {
  if (!address) return null;
  if (address.area && address.area.level.depth > 1) return address.area.name;
  return address.city || null;
};
